import { oc } from '@orpc/contract'
import { z } from 'zod'
import { faxPatientCheckInput } from './check-incoming-fax-patients.contract'

// Records that staff confirmed filing pages the patient check flagged (PD-2053): the server runs
// the check again for the same groups and, when anything is flagged, adds a note to the fax Task
// naming the caller, the time and what was confirmed. Nothing flagged records nothing.
export const reviewIncomingFaxPatients = oc
  .route({ method: 'POST', path: '/v2/incoming-faxes/{id}/patient-review' })
  .input(faxPatientCheckInput)
  .output(z.object({ recorded: z.boolean() }))
